import {
  DC_Domain_Models_P1_Interval,
  DC_Domain_Models_P1_UsageEnergyType,
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  ResponseModels_P1DongleUsage_P1DongleDataStatusResponseModel,
  ResponseModels_P1DongleUsage_P1DongleUsageFlowResponseModel,
  ResponseModels_P1DongleUsage_PowerNowResponseModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type GetPowerNowData = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
};
/**
 * Get realtime usage data from customer
 *
 * @returns ResponseModels_P1DongleUsage_PowerNowResponseModel Success
 */
export function getPowerNowData(
  { businessUnit, label, customerId }: GetPowerNowData,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_P1DongleUsage_PowerNowResponseModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/p1/powernow`,
      errors: { 400: 'Bad Request', 404: 'Not Found' },
    },
    requestConfig,
  );
}

type GetUsageFlow = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  from?: string;
  to?: string;
  interval?: DC_Domain_Models_P1_Interval;
  energyType?: DC_Domain_Models_P1_UsageEnergyType;
};
/**
 * Get usage flow of a customer from their P1 dongle
 *
 * @returns ResponseModels_P1DongleUsage_P1DongleUsageFlowResponseModel Success
 */
export function getUsageFlow(
  { businessUnit, label, customerId, from, to, interval, energyType }: GetUsageFlow,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_P1DongleUsage_P1DongleUsageFlowResponseModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/p1/usageflow`,
      query: { from, to, interval, energyType },
      errors: { 400: 'Bad Request', 404: 'Not Found' },
    },
    requestConfig,
  );
}

type GetDataStatus = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  staleAfterMinutes?: number;
};
/**
 * Get P1 dongle data status for a customer
 *
 * @returns ResponseModels_P1DongleUsage_P1DongleDataStatusResponseModel Success
 */
export function getDataStatus(
  { businessUnit, label, customerId, staleAfterMinutes }: GetDataStatus,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_P1DongleUsage_P1DongleDataStatusResponseModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/p1/data-status`,
      query: { staleAfterMinutes },
      errors: { 400: 'Bad Request', 404: 'Not Found' },
    },
    requestConfig,
  );
}
